import {invalidateOnSuccess, metadaApi} from '@dms/api/base';

import {
  GetServiceOrderCustomVatRateApiArg,
  GetServiceOrderCustomVatRateApiArgSchema,
  GetServiceOrderCustomVatRateApiResponse,
  GetServiceOrderCustomVatRateApiResponseSchema,
  PatchServiceOrderCustomVatRateApiArg,
  PatchServiceOrderCustomVatRateApiArgSchema,
  PatchServiceOrderCustomVatRateApiResponse,
  PatchServiceOrderCustomVatRateApiResponseSchema,
} from './types';

export const metadaWorkshopServiceOrderCustomVatRateApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceOrderCustomVatRate: build.query<
      GetServiceOrderCustomVatRateApiResponse,
      GetServiceOrderCustomVatRateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/custom-vat-rate`,
        queryArg,
      }),
      // isChangeAllowed depends on the service order state, so any service order change refetches it.
      providesTags: (result, error, queryArg) => [
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderCustomVatRateApiResponseSchema,
        requestSchema: GetServiceOrderCustomVatRateApiArgSchema,
      },
    }),
    patchServiceOrderCustomVatRate: build.mutation<
      PatchServiceOrderCustomVatRateApiResponse,
      PatchServiceOrderCustomVatRateApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/custom-vat-rate`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess((result, queryArg) => [
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        // The PATCH changes the VAT of every item, so every cached item detail is stale.
        'workBasketItem',
        'materialOrderItem',
        {type: 'serviceOrderJobTotalAmount', id: queryArg.serviceOrderId},
        {type: 'serviceOrderTotalAmount', id: queryArg.serviceOrderId},
        {type: 'orderProfitability', id: queryArg.serviceOrderId},
        'checkout',
        'afsCheckout',
        'afsPaymentsList',
        {type: 'serviceOrderCheckoutRestriction', id: queryArg.serviceOrderId},
        'afsPaymentIssueRestriction',
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
      ]),
      extraOptions: {
        responseSchema: PatchServiceOrderCustomVatRateApiResponseSchema,
        requestSchema: PatchServiceOrderCustomVatRateApiArgSchema,
      },
    }),
  }),
});

export const {useGetServiceOrderCustomVatRateQuery, usePatchServiceOrderCustomVatRateMutation} =
  metadaWorkshopServiceOrderCustomVatRateApi;
